

































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetPaperEcharts } from "@/request/common";
import echarts from "echarts";
@Component({})
export default class Name extends Vue {
  @Prop()
  private filter: any;
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private ifShowChange() {
    this.ifShowEchart = this.ifShow;
    if (this.ifShow) {
      console.log(this.data);
      this.getData();
    }
  }
  private ifShowEchart: any = false;
  private data: any = {};
  private cancel() {
    this.$emit("cancel");
  }
  private getData() {
    const params: any = {
      params: {
        search_key: this.filter.search_key,
        search_value: this.filter.search_value,
        dimension: this.filter.dimension,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPaperEcharts(this, params, loading).then((res: any) => {
      this.data = res.data;
      if (this.filter.dimension == "期刊" || this.filter.dimension == "作者") {
        const Chart: any = echarts.init(
          this.$refs.echarts as HTMLCanvasElement
        );
        const option: any = {
          color: ["#E08820"],
          grid: {
            top: "20",
            left: "40",
            right: "20",
            bottom: "100",
            //   containLabel: true,
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}",
          },
          xAxis: {
            type: "category",
            data: this.data.name,
            axisLabel: {
              interval: 0, // 显示所有标签
              rotate: 30, // 设置字体倾斜角度为-30度
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.data.data,
              type: "bar",
              barWidth: "30",
              itemStyle: {
                barBorderRadius: [15, 15, 0, 0],
              },
            },
          ],
        };
        Chart.setOption(option);
        // 点击事件
        Chart.off("click");
        Chart.on("click", (p: any) => {});
      } else if (this.filter.dimension == "发文地区") {
        const Chart: any = echarts.init(
          this.$refs.echarts as HTMLCanvasElement
        );
        const option: any = {
          color: ["#E08820"],
          grid: {
            top: "20",
            left: "40",
            right: "20",
            bottom: "100",
            //   containLabel: true,
          },
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}",
          },
          xAxis: {
            type: "category",
            data: this.data.name,
            axisLabel: {
              interval: 0, // 显示所有标签
              rotate: 30, // 设置字体倾斜角度为-30度
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.data.data,
              type: "bar",
              barWidth: "20",
              itemStyle: {
                barBorderRadius: [10, 10, 0, 0],
              },
            },
          ],
        };
        Chart.setOption(option);
        // 点击事件
        Chart.off("click");
        Chart.on("click", (p: any) => {});
      } else if (
        this.filter.dimension == "关键词" ||
        this.filter.dimension == "民族医药种类" ||
        this.filter.dimension == "疾病"
      ) {
        const Chart: any = echarts.init(
          this.$refs.echarts as HTMLCanvasElement
        );
        const option: any = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              data: this.data.data,
              type: "pie",
            },
          ],
        };
        Chart.setOption(option);
        // 点击事件
        Chart.off("click");
        Chart.on("click", (p: any) => {});
      } else if (this.filter.dimension == "发表年份") {
        const Chart: any = echarts.init(
          this.$refs.echarts as HTMLCanvasElement
        );
        const option: any = {
          color: ["#E08820"],
          grid: {
            top: "20",
            left: "40",
            right: "20",
            bottom: "40",
          },
          tooltip: {
            trigger: "axis",
          },
          xAxis: {
            type: "category",
            data: this.data.name,
            axisLabel: {
              interval: 0, // 显示所有标签
              rotate: 30, // 设置字体倾斜角度为-30度
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.data.data,
              type: "line",
            },
          ],
        };
        Chart.setOption(option);
        // 点击事件
        Chart.off("click");
        Chart.on("click", (p: any) => {});
      }
    });
  }
}
